import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Avatar, Heading3, Paragraph, PlainCard, Skeleton } from '@treams/treams-ui';

export default Skeleton(
	function SharedFeedbackCard(props: graphql.SharedByFragment) {
		const { t } = useTranslation();

		return (
			<PlainCard
				to={`/users/${props.sharedBy.id}/feedback/${props.request.id}?return=/feedback/shared`}
			>
				<Flex alignItems="center" style={{ gap: 16 }}>
					<Avatar size={48} user={props.sharedBy as graphql.User} />
					<Box flexGrow={1} flexShrink={1} minWidth={0}>
						<Heading3>{props.request.title || t('feedback.shared.card.title')}</Heading3>
						<Paragraph mt="4px">
							{t('feedback.shared.card.by')}
							&nbsp;
							{props.sharedBy.fullName}
							{' · '}
							{t('feedback.shared.card.createdAt', {
								date: moment(props.createdAt).format('LL'),
							})}
						</Paragraph>
					</Box>
				</Flex>
			</PlainCard>
		);
	},
	function SharedFeedbackCardSkeleton() {
		return (
			<PlainCard.Skeleton>
				<Flex alignItems="center" style={{ gap: 16 }}>
					<Avatar.Skeleton size={48} />
					<Box flexGrow={1} flexShrink={1}>
						<Heading3.Skeleton />
						<Paragraph.Skeleton mt="4px" lines={1} />
					</Box>
				</Flex>
			</PlainCard.Skeleton>
		);
	},
);
